module.exports = __webpack_public_path__ + "fonts/LatoLatin-Medium.ba687a5.woff2";